var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwlGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 277,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 279,
    height: 276
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m154.7 11.51.898.51.995-.272 16.886-4.61 12.557 12.114.745.718 1.034-.018 17.507-.297 9.125 14.83.544.883 1.009.239 17.027 4.034 5.121 16.61.307.994.922.483 15.476 8.108.8 17.347.048 1.043.776.7 12.953 11.67-3.569 16.995-.215 1.024.578.872 9.621 14.498-7.714 15.58-.465.939.343.989 5.686 16.417-11.376 13.188-.683.792.084 1.042 1.396 17.307-14.327 9.968-.856.596-.179 1.027-2.984 17.113-16.38 6.12-.974.363-.428.947-7.18 15.844-17.405 1.884-1.029.111-.649.807-10.927 13.579-17.334-2.473-1.023-.146-.827.619-13.989 10.457-16.171-6.676-.954-.394-.954.394-16.171 6.676-13.989-10.457-.827-.619-1.023.146-17.334 2.473-10.927-13.579-.649-.807-1.03-.111-17.404-1.884-7.18-15.844-.428-.947-.974-.363-16.38-6.12-2.984-17.113-.179-1.027-.856-.596-14.327-9.968 1.396-17.307.084-1.042-.683-.792L5.305 163.91l5.686-16.417.343-.989-.465-.939-7.714-15.58 9.62-14.498.58-.872-.216-1.024L9.57 96.595l12.953-11.67.776-.699.048-1.043.8-17.347 15.476-8.108.922-.483.307-.995 5.121-16.61L63 35.608l1.01-.24.543-.883 9.125-14.829 17.508.297 1.033.018.745-.718L105.52 7.137l16.886 4.611.995.272.898-.51 15.2-8.635 15.2 8.635Z",
    fill: "#D9D9D9",
    stroke: "#70C1BB",
    strokeWidth: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.7 11.51.898.51.995-.272 16.886-4.61 12.557 12.114.745.718 1.034-.018 17.507-.297 9.125 14.83.544.883 1.009.239 17.027 4.034 5.121 16.61.307.994.922.483 15.476 8.108.8 17.347.048 1.043.776.7 12.953 11.67-3.569 16.995-.215 1.024.578.872 9.621 14.498-7.714 15.58-.465.939.343.989 5.686 16.417-11.376 13.188-.683.792.084 1.042 1.396 17.307-14.327 9.968-.856.596-.179 1.027-2.984 17.113-16.38 6.12-.974.363-.428.947-7.18 15.844-17.405 1.884-1.029.111-.649.807-10.927 13.579-17.334-2.473-1.023-.146-.827.619-13.989 10.457-16.171-6.676-.954-.394-.954.394-16.171 6.676-13.989-10.457-.827-.619-1.023.146-17.334 2.473-10.927-13.579-.649-.807-1.03-.111-17.404-1.884-7.18-15.844-.428-.947-.974-.363-16.38-6.12-2.984-17.113-.179-1.027-.856-.596-14.327-9.968 1.396-17.307.084-1.042-.683-.792L5.305 163.91l5.686-16.417.343-.989-.465-.939-7.714-15.58 9.62-14.498.58-.872-.216-1.024L9.57 96.595l12.953-11.67.776-.699.048-1.043.8-17.347 15.476-8.108.922-.483.307-.995 5.121-16.61L63 35.608l1.01-.24.543-.883 9.125-14.829 17.508.297 1.033.018.745-.718L105.52 7.137l16.886 4.611.995.272.898-.51 15.2-8.635 15.2 8.635Z",
    stroke: "#70C1BB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.212 202.658-16.308-5.153s-6.4 2.883-6.607 7.414c-.423 9.263 1.652 14.631 1.652 14.631l8.258 1.027 15.27-4.946 6.192-6.18",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.212 202.658-16.308-5.153s-6.4 2.883-6.607 7.414c-.423 9.263 1.652 14.631 1.652 14.631l8.258 1.027 15.27-4.946 6.192-6.18",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.944 223.469c9.08 8.243 35.912 1.649 45.821-12.36l.415-44.09c-7.021 3.297-14.657 2.27-27.87 18.954-3.444 4.35-9.286 12.361-14.656 11.541-5.669-.87-5.162-9.892-5.162-9.892s-7.221 7.622-1.444 14.423",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.944 223.469c9.08 8.243 35.912 1.649 45.821-12.36l.415-44.09c-7.021 3.297-14.657 2.27-27.87 18.954-3.444 4.35-9.286 12.361-14.656 11.541-5.669-.87-5.162-9.892-5.162-9.892s-7.221 7.622-1.444 14.423",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.741 209.617c-3.51 2.933-6.888 3.662-9.12 3.322",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.556 206.842c1.436-.025 2.863.249 4.208.92 7.054 3.537 8.532-1.359 9.503.149.97 1.508 3.444 10.546-1.51 16.511-2.3 2.767-7.778 4.192-9.43 3.993-1.65-.207-10.116-1.442-10.324-12.982-.174-9.908 6.4-16.072 6.4-16.072",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.556 206.842c1.436-.025 2.863.249 4.208.92 7.054 3.537 8.532-1.359 9.503.149.97 1.508 3.444 10.546-1.51 16.511-2.3 2.767-7.778 4.192-9.43 3.993-1.65-.207-10.116-1.442-10.324-12.982-.174-9.908 6.4-16.072 6.4-16.072",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.248 211.615c2.233.331 7.353 1.623 10.574-2.013M65.905 216.701c1.91.174 6.39-1.673 8.258-3.927M66.76 220.039c2.134.075 5.254-1.682 7.47-3.72M67.366 223.842c2.233.331 5.121-2.22 6.44-3.894",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.832 276.231c0 3.356-3.726 6.935-8.78 6.603-4.482-.29-6.042-.141-8.499 0-1.818.108-7.005 1.939-9.354.853-2.348-1.085-4.382-5.012.133-6.453 4.523-1.442 10.79 1.342 12.051.795",
    fill: "#E97D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.832 276.231c0 3.356-3.726 6.935-8.78 6.603-4.482-.29-6.042-.141-8.499 0-1.818.108-7.005 1.939-9.354.853-2.348-1.085-4.382-5.012.133-6.453 4.523-1.442 10.79 1.342 12.051.795",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.815 260.457h-14.566v17.704h14.566v-17.704Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.814 274.581v3.098c0 3.355-3.727 6.934-8.781 6.603-4.482-.29-6.042-.141-8.499 0-1.817.107-7.004 1.938-9.353.853s-4.382-5.012.133-6.454c4.523-1.441 10.664-.472 11.934-1.01v-3.099",
    fill: "#E97D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.814 274.581v3.098c0 3.355-3.727 6.934-8.781 6.603-4.482-.29-6.042-.141-8.499 0-1.817.107-7.004 1.938-9.353.853s-4.382-5.012.133-6.454c4.523-1.441 10.664-.472 11.934-1.01v-3.099",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.832 276.231c0 3.356-3.726 6.935-8.78 6.603-4.482-.29-6.042-.141-8.499 0-1.818.108-7.005 1.939-9.354.853-2.348-1.085-4.382-5.012.133-6.453 4.523-1.442 10.79 1.342 12.051.795",
    fill: "#E97D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.832 276.231c0 3.356-3.726 6.935-8.78 6.603-4.482-.29-6.042-.141-8.499 0-1.818.108-7.005 1.939-9.354.853-2.348-1.085-4.382-5.012.133-6.453 4.523-1.442 10.79 1.342 12.051.795",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.815 260.457h-14.566v17.704h14.566v-17.704Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.814 274.581v3.098c0 3.355-3.727 6.934-8.781 6.603-4.482-.29-6.042-.141-8.499 0-1.817.107-7.004 1.938-9.353.853s-4.382-5.012.133-6.454c4.523-1.441 10.664-.472 11.934-1.01v-3.099",
    fill: "#E97D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.814 274.581v3.098c0 3.355-3.727 6.934-8.781 6.603-4.482-.29-6.042-.141-8.499 0-1.817.107-7.004 1.938-9.353.853s-4.382-5.012.133-6.454c4.523-1.441 10.664-.472 11.934-1.01v-3.099",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.481 276.231c0 3.356-3.727 6.935-8.781 6.603-4.482-.29-6.042-.141-8.499 0-1.817.108-7.004 1.939-9.353.853-2.349-1.085-4.382-5.012.133-6.453 4.523-1.442 10.789 1.342 12.059.795",
    fill: "#E97D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.481 276.231c0 3.356-3.727 6.935-8.781 6.603-4.482-.29-6.042-.141-8.499 0-1.817.108-7.004 1.939-9.353.853-2.349-1.085-4.382-5.012.133-6.453 4.523-1.442 10.789 1.342 12.059.795",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.464 260.457h-14.566v17.704h14.566v-17.704Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.465 274.581v3.098c0 3.355-3.726 6.934-8.781 6.603-4.481-.29-6.042-.141-8.498 0-1.818.107-7.005 1.938-9.354.853-2.349-1.085-4.382-5.012.133-6.454 4.515-1.441 10.665-.472 11.935-1.01v-3.099",
    fill: "#E97D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.465 274.581v3.098c0 3.355-3.726 6.934-8.781 6.603-4.481-.29-6.042-.141-8.498 0-1.818.107-7.005 1.938-9.354.853-2.349-1.085-4.382-5.012.133-6.454 4.515-1.441 10.665-.472 11.935-1.01v-3.099",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.424 165.088c-11.569-11.118-46.253-2.411-46.253-2.411-.025-1.408-.041-2.204-.041-2.204l-8.64 1.102-8.64-1.102s-.016.796-.041 2.204l-54.113 6.893s-9.403 96.771 34.908 100.673c12.93 1.135 19.62-1.632 25.164-5.079a5.195 5.195 0 0 1 5.444 0c5.544 3.455 13.561 5.302 25.164 5.079 44.112-.854 38.626-94.037 27.048-105.155Z",
    fill: "#B2B6B9",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.791 169.239c-.415-2.187-1.196-4.241-2.615-5.815-4.905-5.435-18.433-2.138-24.699-1.094a9.554 9.554 0 0 1-.05-1.822c-2.556.306-5.245.687-7.851 1.052l-7.851-1.102s-.017.795-.034 2.203c-.049 3.223-29.255-1.093-31.073 8.981-.581 3.223.216 6.536 1.079 9.684 3.287 11.922 7.86 23.827 15.935 32.583 8.067 8.757 20.276 13.786 31.073 9.942 6.906-2.461 12.508-8.202 16.674-14.722 6.465-10.124 9.959-22.509 9.843-34.869-.016-1.657-.124-3.38-.431-5.021Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.544 197.564c-.357 5.973 3.967 24.464 16.275 31.995 12.308 7.531 9.66 16.362 12.3 16.08 2.639-.281 18.707-11.217 17.91-27.38-1.112-22.501-26.558-45.681-38.12-48.771",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.544 197.564c-.357 5.973 3.967 24.464 16.275 31.995 12.308 7.531 9.66 16.362 12.3 16.08 2.639-.281 18.707-11.217 17.91-27.38-1.112-22.501-26.558-45.681-38.12-48.771",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.587 223.097c3.17 3.396 10.922 10.504 11.661 20.711M228.243 220.828c3.171 3.397 6.806 10.107 8.582 19.899M233.379 218.192c2.598 3.049 6.631 13.098 6.93 19.204M237.571 215.352c2.797 3.545 5.163 11.159 6.109 17.588M241.871 211.491c3.17 3.397 4.49 11.623 4.631 16.039",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.196 164.797s15.827 10.985 53.399 16.254c37.58 5.261 54.926-3.529 54.926-3.529s-22.849-25.318-24.201-25.284c-1.345.033-37.97-5.319-37.97-5.319l-30.293 19.659-15.86-1.781Z",
    fill: "#fff",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.979 94.711c-7.652-28.333-48.568-42.996-68.761-45.83-20.193-2.825-63.565.033-78.737 25.16-15.171 25.127-26.583 61.96-18.051 77.452 13.727 24.936 50.701 30.495 76.869.422 17.205 36.817 66.612 40.901 84.68 22.211 12.3-12.725 11.652-51.09 4-79.415Z",
    fill: "#B2B6B9",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.624 67.754c-5.96-2.668-16.292-10.373-20.01-18.458 0 0-10.15 24.555 2.531 35.623",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.624 67.754c-5.96-2.668-16.292-10.373-20.01-18.458 0 0-10.15 24.555 2.531 35.623",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.641 82.516c-17.637-2.47-36.875 8.475-43.954 15.367-2.291 2.229-6.349 1.657-7.935-1.11-4.905-8.574-10.789-23.03-28.425-25.508-34.891-4.888-55.582 61.165-38.203 82.829 14.624 18.225 49.399 11.043 63.798-5.261 7.428 16.826 49.515 37.313 68.595 23.809 22.691-16.055 21.828-85.123-13.876-90.126Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.719 139.911-.066.307c.017-.199.025-.315.025-.315-2.141-.298-5.586 5.31-5.37 8.21.216 2.9-1.236 6.893-.382 7.647.864.762 8.599-3.795 9.221-8.277.398-2.874-1.286-7.273-3.428-7.572Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.366 136.092-.058-.008c-3.071-.431-8.972 3.794-9.918 7.854-.788 3.396 3.909 16.279 3.926 16.279 1.701.041 1.834-12.634 10.664-13.048 1.445-3.919-1.535-10.646-4.614-11.077Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.332 126.695c1.36-9.674-2.77-18.249-9.225-19.154-6.454-.904-12.79 6.205-14.15 15.879-1.36 9.673 2.77 18.249 9.224 19.153 6.455.904 12.791-6.205 14.151-15.878ZM186.993 134.715c1.36-9.673-2.77-18.249-9.224-19.153-6.455-.904-12.79 6.205-14.151 15.878-1.36 9.674 2.77 18.249 9.225 19.154 6.454.904 12.79-6.205 14.15-15.879Z",
    fill: "#3E3E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.613 49.296S72.09 65.053 84.481 74.05",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.614 49.296s-7.088 21.316 5.295 30.313",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.053 85.325c6.465-.928 18.524-5.501 24.325-12.245 0 0 2.988 26.394-12.258 33.552",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.053 85.325c6.465-.928 18.524-5.501 24.325-12.245 0 0 2.988 26.394-12.258 33.552",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.387 73.08s0 16.387-14.391 21.63",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.387 73.08s.938 22.443-13.453 27.687",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.03 89.955c-17.835-2.501-34.326 9.909-36.833 27.72-2.506 17.804 9.926 34.265 27.77 36.767 17.836 2.502 34.327-9.908 36.833-27.72 2.498-17.803-9.926-34.265-27.77-36.767Zm-8.341 59.359c-14.997-2.105-25.454-15.948-23.346-30.918 2.108-14.97 15.976-25.408 30.973-23.304 14.998 2.104 25.455 15.947 23.347 30.917-2.108 14.971-15.977 25.401-30.974 23.305Z",
    fill: "#31B1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.752 128.569-9.444-6.727 1.601-11.367 10.93-3.869-3.087 21.963ZM152.745 128.818c-2.506 17.803 9.926 34.264 27.77 36.766 17.836 2.502 34.327-9.908 36.833-27.72 2.507-17.803-9.926-34.264-27.77-36.766-17.844-2.502-34.335 9.916-36.833 27.72Zm5.137.72c2.109-14.97 15.977-25.408 30.974-23.304 14.997 2.104 25.455 15.948 23.346 30.918-2.108 14.97-15.968 25.408-30.973 23.304-14.997-2.104-25.455-15.947-23.347-30.918Z",
    fill: "#31B1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.805 148.196 24.583-1.963 1.602-11.367-23.098-8.64-3.087 21.97ZM157.533 117.924l-21.78-3.052-1.267 9.008 21.78 3.052 1.267-9.008Z",
    fill: "#31B1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.688 177.075-1.22 6.694s-10.898 4.25-13.014 2.485c-2.116-1.764 1.527-17.704 3.469-18.043 1.942-.348 10.765 8.864 10.765 8.864ZM142.368 177.921l-1.22 6.694s8.707 7.804 11.313 6.893c2.606-.911 4.797-17.116 3.104-18.11-1.693-1.002-13.197 4.523-13.197 4.523Z",
    fill: "#31B1B6",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.363 177.942-5.079-.92-1.216 6.693 5.079.919 1.216-6.692Z",
    fill: "#31B1B6",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m154.7 11.51.898.51.995-.272 16.886-4.61 12.557 12.114.745.718 1.034-.018 17.507-.297 9.125 14.83.544.883 1.009.239 17.027 4.034 5.121 16.61.307.994.922.483 15.476 8.108.8 17.347.048 1.043.776.7 12.953 11.67-3.569 16.995-.215 1.024.578.872 9.621 14.498-7.714 15.58-.465.939.343.989 5.686 16.417-11.376 13.188-.683.792.084 1.042 1.396 17.307-14.327 9.968-.856.596-.179 1.027-2.984 17.113-16.38 6.12-.974.363-.428.947-7.18 15.844-17.405 1.884-1.029.111-.649.807-10.927 13.579-17.334-2.473-1.023-.146-.827.619-13.989 10.457-16.171-6.676-.954-.394-.954.394-16.171 6.676-13.989-10.457-.827-.619-1.023.146-17.334 2.473-10.927-13.579-.649-.807-1.03-.111-17.404-1.884-7.18-15.844-.428-.947-.974-.363-16.38-6.12-2.984-17.113-.179-1.027-.856-.596-14.327-9.968 1.396-17.307.084-1.042-.683-.792L5.305 163.91l5.686-16.417.343-.989-.465-.939-7.714-15.58 9.62-14.498.58-.872-.216-1.024L9.57 96.595l12.953-11.67.776-.699.048-1.043.8-17.347 15.476-8.108.922-.483.307-.995 5.121-16.61L63 35.608l1.01-.24.543-.883 9.125-14.829 17.508.297 1.033.018.745-.718L105.52 7.137l16.886 4.611.995.272.898-.51 15.2-8.635 15.2 8.635Z",
    stroke: "#70C1BB",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwlGood);
export default __webpack_public_path__ + "static/media/owl-good.65f1a59292e239d797fee32cc5bfef88.svg";
export { ForwardRef as ReactComponent };